import { get } from "../../utils/request";

// Home SectionTwo
export const getSlide = async () => {
  const res = await get("slide");
  return res;
};
// End Home SectionTwo

// Home SectionThree
export const getMightLike = async () => {
  const res = await get("might-like");
  return res;
};
//End Home SectionThree

// Home SectionFour
export const getByStyle = async () => {
  const res = await get("by-style");
  return res;
};
//End Home SectionFour

// Home SectionFive
export const getPopularWeek = async () => {
  const res = await get("popular-Week");
  return res;
};
//End Home SectionFive

// Home SectionSix
export const getByPrice = async () => {
  const res = await get("by-price");
  return res;
};
//End Home SectionSix
